import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import SwitchButton from 'Components/Form/SwitchButton'
import { SCHOOL_PARAMS } from 'Defaults/school'
import { GA_CATEGORIES } from 'Defaults/googleAnalytics'
import { manageSchoolFilters } from 'Utils/schoolUtils'
// import { hasAreaOnParam, buildAreaKey, removeAllAreaParams, getAllAreas } from 'Utils/mapUtils'
import useDisableBackButton from 'Hooks/useDisableBackButton'
import { addOrRemoveQueries, removeQueries } from 'Utils/routerUtils'
import SearchPageMobileContainer from '../SearchPageMobileContainer'

import {
  _TitleContainer, _FilterLabel, _Content, _BoxItemContainer,
  _MultiSelectedBoxes, _SchoolFilterSwitch, _ApplyBtn, _BtnContainer,
  _ToggleLabel, _SwitchContainer,
} from './styles'
import {
  schoolAllFilters,
  schoolFilterKeys,
  schoolFiltersMap,
} from '../../../../../components/SearchMap/components/MapSchoolFilters/data'

import { SelectableBox } from '../../../../../components/SearchFilterFactory/PanelForms'

export const MobileSchoolFilters = (
  {
    googleAnalyticsEvent,
    toggleMobileFilter,
    isMobileApp,
    filterButtonActive,
    schoolLevel,
    schoolType,
    schoolLanguage,
    schoolEnabled = false,
  },
) => {
  const [toggleSwitch, setToggleSwitch] = useState(false)
  const closeMobileFilter = () => {
    toggleMobileFilter(false)
  }
  const lastSearchObj = {
    school_level: schoolLevel || '',
    school_type: schoolType || '',
    school_language: schoolLanguage || '',
  }
  const currentFilters = R.pick(schoolFilterKeys, lastSearchObj)
  // remove all school related fields on school switch disabled
  useEffect(() => {
    if(!schoolEnabled) {
      removeQueries([
        ...schoolFilterKeys,
        SCHOOL_PARAMS.SELECTED_SCHOOL_ID,
      ], false)
    }
  }, [schoolEnabled])
  /**
   * on filter checkbox click
   * @param {string} key
   * @param {Object} data
   */
  const onClickFilter = ({ key, data }) => {
    const paramFilters = schoolFilterKeys.reduce((acc, k) => {
      if(currentFilters?.[k]) {
        const paramVal = currentFilters?.[k]?.split(',')
        acc[k] = paramVal
      }
      return acc
    }, {})
    const filters = manageSchoolFilters(paramFilters, key, data)
    filters[SCHOOL_PARAMS.SELECTED_SCHOOL_ID] = []
    googleAnalyticsEvent({
      category: GA_CATEGORIES.SEARCH,
      action: ['Mobile School Filter Select', key, data.value],
    })
    addOrRemoveQueries(filters, false)
  }
  /**
   * Add all school filter on enable and remove all on deactivate
   */
  const onSwitchChange = (switchOn) => {
    googleAnalyticsEvent({
      category: GA_CATEGORIES.SEARCH,
      action: [`Mobile School Filter ${switchOn ? 'Disabled' : 'Enabled'}`],
    })
    setToggleSwitch(!switchOn)
    if(!switchOn) {
      addOrRemoveQueries(schoolAllFilters, false)
    } else {
      removeQueries(schoolFilterKeys, false)
    }
  }

  useDisableBackButton({
    enabled: filterButtonActive,
    onBackButtonPress: () => closeMobileFilter(),
  })
  const dropdownContentElement = (
    schoolFilterKeys.map((key) => {
      const { label, children } = schoolFiltersMap[key]
      return (
        <div key={label}>
          <_FilterLabel>{label}</_FilterLabel>
          <_MultiSelectedBoxes wrap>
            {
              children.map(data => {
                const checked = currentFilters?.[key]?.indexOf(data.value) > -1
                return (
                  <_BoxItemContainer
                    key={data.value}
                    xs={6}
                    sm={6}
                    md={6}
                    lg={6}
                  >
                    <SelectableBox
                      ariaLabel={`${data.label}`}
                      onClick={() => onClickFilter({ key, data })}
                      label={data.label}
                      selected={checked}
                    />
                  </_BoxItemContainer>
                )
              })
            }
          </_MultiSelectedBoxes>
        </div>)
    })
  )
  return (
    <SearchPageMobileContainer
      onCloseClick={() => {
        closeMobileFilter()
        googleAnalyticsEvent({
          category: 'search',
          action: '[Mobile School filters Close Btn Clicked]',
        })
      }}
      hideHeader={isMobileApp}
    >
      <_TitleContainer>School Filter</_TitleContainer>
      <_SchoolFilterSwitch
        key={'schoolFilterSwitch'}
      >
        <_ToggleLabel>Show schools</_ToggleLabel>

        <_SwitchContainer>
          <SwitchButton
            data-test-id="schoolFilterSwitch"
            inputId="schoolFilterSwitch"
            isOn={schoolEnabled}
            onChange={() => onSwitchChange(toggleSwitch)}
          />
        </_SwitchContainer>
      </_SchoolFilterSwitch>
      <_Content>
        {dropdownContentElement}
      </_Content>
      <_BtnContainer>
        <_ApplyBtn
          primary
          onClick={() => {
            closeMobileFilter()
            googleAnalyticsEvent({
              category: 'search',
              action: '[Mobile School Filter Apply Btn Clicked]',
            })
          }}
        >Apply
        </_ApplyBtn>
      </_BtnContainer>

    </SearchPageMobileContainer>
  )
}

MobileSchoolFilters.propTypes = {
  googleAnalyticsEvent: PropTypes.func,
  basicSearch: PropTypes.shape({
    keys: PropTypes.arrayOf(PropTypes.string),
    data: PropTypes.shape({}),
  }),
  advanceSearch: PropTypes.shape({
    keys: PropTypes.arrayOf(PropTypes.string),
    data: PropTypes.shape({}),
  }),
  toggleMobileFilter: PropTypes.func,
  isMobileApp: PropTypes.bool,
  filterButtonActive: PropTypes.bool,
  schoolEnabled: PropTypes.bool,
  schoolLevel: PropTypes.string,
  schoolType: PropTypes.string,
  schoolLanguage: PropTypes.string,

}

export default MobileSchoolFilters
